export default {
	data: function () {
		return {
			percentFormatter: new Intl.NumberFormat('ru-RU', {
				style: 'percent',
				minimumFractionDigits: 2,
				signDisplay: 'always' // Автоматически ставит "+" (нужно расти) или "-" (нужно падать)
			})
		}
	},
	methods: {
		/**
		 * Получение суммы в корректном формате для русской локали с символом рубля.
		 * @param number
		 * @param needRub
		 * @return {string}
		 */
		getFormattedCurrency(number, needRub = true, minimumFractionDigits = 2) {
			let option = needRub ? {
				style: 'currency',
				currency: 'RUB',
				minimumFractionDigits: minimumFractionDigits
			} : {
				minimumFractionDigits: minimumFractionDigits
			};

			return new Intl.NumberFormat('ru-RU', option).format(number);
		}
	}
};